import { useState, useEffect } from 'react';
import axios from 'axios';
// import MainHeader from '../components/MainHeader';
import {
  PageBody,
  MainColumn,
  CardSection,
  CardTitle,
  Row,
  Label,
  Input,
  Select,
  ButtonRow,
  TabButton,
  Button,
  ButtonSecondary,
  DenominationRow,
  LeftGroup,
  DenominationAmount,
  DenominationInput,
  DenominationTotal,
  TotalsBox,
  MilkRow,
  MilkInput,
  MilkLabel,
  InfoCard,
  SummaryValue,
  DiscrepancyButton,
  InputDigitalSettlement
} from '../styles/cashFlow.styles';
import Loader from '../components/Loader';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// ---------------------------
// CENTRALIZED FIELD VALIDATION
// ---------------------------
const FIELD_VALIDATIONS = {
  // opening form
  denom: { required: true, nonNegative: true, decimal: 1 },
  bank: { required: true, nonNegative: true, decimal: 1 },
  milkOrdered: { required: true, nonNegative: true, decimal: 1 },
  milkReceived: { required: true, nonNegative: true, decimal: 1 },
  milkExtra: { required: false },

  // closing form
  closingDenom: { required: true, nonNegative: true, decimal: 1 },
  salesZomatoGold: { required: false, nonNegative: true, decimal: 1 },
  salesPayTM: { required: false, nonNegative: true, decimal: 1 },
  salesDineout: { required: false, nonNegative: true, decimal: 1 },
  salesEasyDiner: { required: false,nonNegative: true, decimal: 1 },
  salesAmex: { required: false, nonNegative: true, decimal: 1 },
  salesSwiggy: { required: false, nonNegative: true, decimal: 1 },
  salesZomato: { required: false, nonNegative: true, decimal: 1 },
  salesKotak: { required: false, nonNegative: true, decimal: 1 },
  salesPetPooja: { required: true, positive: true, decimal: 1 },
  expenses: { required: false, positive: true, decimal: 1 },
  pendingBills: { required: false, nonNegative: true, decimal: 1 },
  // Notes/remarks: text, allow empty
  remarks: { required: false, text: true }
};

function validateField(field, value, customRules = {}) {
  const rules = { ...FIELD_VALIDATIONS[field], ...customRules };
  if (rules.text) return { valid: true, error: "" };

  // If not required and empty, consider valid immediately
  if (!rules.required && (value === "" || value == null)) {
    return { valid: true, error: "" };
  }

  if (rules.required && (value === "" || value == null || (typeof value === "number" && isNaN(value)))) {
    return { valid: false, error: "Required" };
  }

  const num = typeof value === 'number' ? value : (value === "" ? null : Number(value));

  if (rules.nonNegative && (num === null || isNaN(num) || num < 0)) {
    return { valid: false, error: "Must be zero or positive" };
  }

  if (rules.positive && (num === null || isNaN(num) || num <= 0)) {
    return { valid: false, error: "Must be positive" };
  }

  if (rules.decimal !== undefined) {
    if (!/^([0-9]+(\.[0-9]?)?)$/.test(String(value))) {
      return { valid: false, error: "Max 1 decimal place allowed" };
    }
  }

  return { valid: true, error: "" };
}



// Validate all fields of a form
function validateForm(formData, fields) {
  const errors = {};
  for (const field of fields) {
    // handle denomination objects
    if (field === 'denom' || field === 'bank' || field === 'closingDenom') {
      // for (const denom of DENOMS) {
      //   const { valid, error } = validateField(field, formData[field][denom]);
      //   if (!valid) {
      //     if (!errors[field]) errors[field] = {};
      //     errors[field][denom] = error;
      //   }
      // }
    } else {
      const { valid, error } = validateField(field, formData[field]);
      if (!valid) errors[field] = error;
    }
  }
  return errors;
}

// --- END CENTRALIZED VALIDATION SECTION ---

export default function CashFlow() {
  const getLocalFormattedDate = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().split('T')[0];
};
const getReportDateDefault = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset()-6*60);
  return now.toISOString().split('T')[0];
};
  const userData = JSON.parse(localStorage.getItem('user') || '{}');
  const [DENOMS,setDenoms] = useState([2000, 500, 200, 100, 50, 20, 10]);

  const isAdmin = userData.roles.role_name == "SUPER_ADMIN"
  const token = localStorage.getItem('access_token');
  const headers = { Authorization: `Bearer ${token}` };
  const [digitalDenoms, setDigitalDenoms] = useState([]); // fetched data for digital currency denominations
  const [digitalSettlements, setDigitalSettlements] = useState([]); // fetched digital settlements data
  const [allDenoms ,setAllDenoms ] = useState([2000, 500, 200, 100, 50, 20, 10])
  const [date,setDate] = useState(getReportDateDefault())
  const [denomDiscrepancies, setDenomDiscrepancies] = useState(Object.fromEntries(digitalDenoms.map((d) => [d, false])));
  const [todayReportStatus, setTodayReportStatus] = useState({});
  const [totalOpeningToday, setTotalOpeningToday] = useState(0);
  const [prevClosingDenom, setPrevClosingDenom] = useState(Object.fromEntries(digitalDenoms.map((d) => [d, 0])));
  const hasDiscrepancy = Object.values(denomDiscrepancies).some(Boolean);
  const [activeTab, setActiveTab] = useState('opening');
  const [stores, setStores] = useState([]);
  const [flagDiscrepancy, setFlagDiscrepancy] = useState(false);
  const [toggleBanking, setToggleBanking] = useState(false);
  const [isLoading,setIsLoading] = useState(false)
  const [openingFormData, setOpeningFormData] = useState({
    date: getReportDateDefault(),
    location: userData.store_id || '',
    openingEmployee: userData.username || '',
    denom: Object.fromEntries(digitalDenoms.map((d) => [d, 0])),
    bank: Object.fromEntries(digitalDenoms.map((d) => [d, 0])),
    milkOrdered: '',
    milkReceived: '',
    milkExtra: '',
  });
  const [closingFormData, setClosingFormData] = useState({
    date: getReportDateDefault(),
    location: userData.store_id || '',
    closingEmployee: userData.username || '',
    closingDenom: Object.fromEntries(digitalDenoms.map((d) => [d, 0])),
    salesZomatoGold: '',
    salesPayTM: '',
    salesDineout: '',
    salesEasyDiner: '',
    salesAmex: '',
    salesSwiggy: '',
    salesZomato: '',
    salesKotak: '',
    salesPetPooja: '',
    expenses: '',
    pendingBills: '',
    remarks: '', // notes/remarks allowed to be text and optional
     digitalSales: {}, 
     dues_received : ''
  });

  // --- Add error states for the forms
  const [openingFormErrors, setOpeningFormErrors] = useState({});
  const [closingFormErrors, setClosingFormErrors] = useState({});
  const [globalFormError, setGlobalFormError] = useState("");

  // Central validation for fields (editable)
  const OPENING_FIELDS = ['denom', 'bank', 'milkOrdered', 'milkReceived', 'milkExtra'];
  const CLOSING_FIELDS = [
    'closingDenom',
    'salesZomatoGold', 'salesPayTM', 'salesDineout', 'salesEasyDiner', 'salesAmex',
    'salesSwiggy', 'salesZomato', 'salesKotak', 'salesPetPooja',
    'expenses', 'pendingBills', 'remarks'
  ];
 const fetchCurrencyDenoms = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${BACKEND_URL}/settings/currency-denomination`, { headers });
      setDigitalDenoms(res.data.filter(item => item.is_active === true)
  .map(item => Number(item.currency_denom_value))
  .sort((a, b) => b - a));
  setAllDenoms(res.data.filter(item => item.is_active === true)
  .map(item => Number(item.currency_denom_value))
  .sort((a, b) => b - a))
    } catch {
      console.log('Failed to fetch currency denominations');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDigitalSettlements = async () => {
    setIsLoading(true)
    try {
      const res = await axios.get(`${BACKEND_URL}/settings/digital-settlement`, { headers });
      setDigitalSettlements(res.data.filter(item => item.is_active === true));
    } catch {
      console.log('Failed to fetch digital settlements');
    } finally {
      setIsLoading(false);
    }
  };
  const isAfterTenAM = () => {
    const now = new Date();
    // console.log("Check for now")
    const hours = now.getHours();
    return hours > 10 && userData.roles.role_name != "SUPER_ADMIN" && false;
  };

   const fetchAdminCashflowData = async (store_id,dateVal) => {
    setIsLoading(true)
    try {
      if(userData.roles.role_name != "SUPER_ADMIN")
        return
      console.log("Ashmin testing for headers :",headers)
      const today = new Date();
      var todayStr = today.toISOString().split('T')[0];
      console.log("today str",todayStr)
      const storeId = store_id;
      console.log("Ashmin testing for store change :",store_id)
      if(!storeId)
        return
      if(dateVal)
        todayStr = dateVal

      const params = {};
if (storeId !== undefined && storeId !== null) params.store_id = storeId;
if (todayStr) params.date = todayStr;

      const [storesRes, openingDenomsRes, prevClosingDenomsRes, reportStatusRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/store`, { headers }),
        axios.get(`${BACKEND_URL}/reports/opening/today`, { params, headers }),
        axios.get(`${BACKEND_URL}/reports/closing/prev`, { params, headers }),
        axios.get(`${BACKEND_URL}/reports/status/today`, { params, headers }),
      ]);
      setTodayReportStatus(reportStatusRes.data);
      if(reportStatusRes.data.opening_report_filed || isAfterTenAM())
        setActiveTab('closing')
      else
        setActiveTab('opening')
      setOpeningFormErrors({})
      setClosingFormErrors({})
      setStores(storesRes.data);

      if (prevClosingDenomsRes.data) {
        console.log("Ashmin testing for prev closing data :",Object.keys(prevClosingDenomsRes.data)
  .map(Number)
  .sort((a, b) => b - a))
        setDigitalDenoms(Object.keys(prevClosingDenomsRes.data)
  .map(Number)
  .sort((a, b) => b - a))
  console.log("Denom new values : ",prevClosingDenom.data)
        const mappedPrevClosing = Object.fromEntries(
          Object.keys(prevClosingDenomsRes.data)
  .map(Number)
  .sort((a, b) => b - a).map((d) => [d, Number(prevClosingDenomsRes.data[String(d)]) || 0])
        );
        setOpeningFormData({...openingFormData, prevClosingDenom : mappedPrevClosing})
        setPrevClosingDenom(mappedPrevClosing);
      } else {
        console.log("Ashmin testing for all denoms",allDenoms,digitalDenoms)
        setDigitalDenoms(allDenoms)
        setPrevClosingDenom(Object.fromEntries(digitalDenoms.map((d) => [d, 0])));
      }

      // Map opening denominations
      let mappedOpeningDenoms = Object.fromEntries(digitalDenoms.map((d) => [d, 0]));
      if (openingDenomsRes.data) {
                setDigitalDenoms(allDenoms)

        mappedOpeningDenoms = Object.fromEntries(
          digitalDenoms.map((d) => [d, Number(openingDenomsRes.data[String(d)]) || 0])
        );
      }
      // Calculate total of opening denominations
      const openingDenomTotal = digitalDenoms.reduce(
        (sum, d) => sum + d * mappedOpeningDenoms[d], 0
      );
      setTotalOpeningToday(openingDenomTotal);
      setIsLoading(false)
    } catch (err) {
      setIsLoading(false)
      console.error('Error fetching initial data:', err);
    }
  };

  const fetchAllData = async () => {
    setIsLoading(true)
    try {
      if(userData.roles.role_name == "SUPER_ADMIN"){
        setTodayReportStatus({
          opening_report_filed : true,
          closing_report_filed:true
        })
        return
      }
      console.log("Ashmin testing for headers normal :",headers)
      const today = new Date();
      var todayStr = today.toISOString().split('T')[0];
      const storeId = userData.store_id;
      openingFormData.location = userData.store_id;
      closingFormData.location = userData.store_id;
      if(date)
        todayStr = date
      const params = {};
if (storeId !== undefined && storeId !== null) params.store_id = storeId;
if (todayStr) params.date = todayStr;

      const [storesRes, openingDenomsRes, prevClosingDenomsRes, reportStatusRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/store`, { headers }),
        axios.get(`${BACKEND_URL}/reports/opening/today`, { params, headers }),
        axios.get(`${BACKEND_URL}/reports/closing/prev`, { params, headers }),
        axios.get(`${BACKEND_URL}/reports/status/today`, { params, headers }),
      ]);
       setTodayReportStatus(reportStatusRes.data);
      if(reportStatusRes.data.opening_report_filed || isAfterTenAM())
        setActiveTab('closing')
      else
        setActiveTab('opening')
      setOpeningFormErrors({})
      setClosingFormErrors({})
      setStores(storesRes.data);

      if (prevClosingDenomsRes.data) {
        console.log("Ashmin testing for prev closing data :",Object.keys(prevClosingDenomsRes.data)
  .map(Number)
  .sort((a, b) => b - a))

        setDigitalDenoms(Object.keys(prevClosingDenomsRes.data)
  .map(Number)
  .sort((a, b) => b - a))
  console.log("Denom new values : ",prevClosingDenom.data)
        const mappedPrevClosing = Object.fromEntries(
          Object.keys(prevClosingDenomsRes.data)
  .map(Number)
  .sort((a, b) => b - a).map((d) => [d, Number(prevClosingDenomsRes.data[String(d)]) || 0])
        );
        setOpeningFormData({...openingFormData, prevClosingDenom : mappedPrevClosing})
        setPrevClosingDenom(mappedPrevClosing);
      } else {
        console.log("Ashmin testing for all denoms",allDenoms,digitalDenoms)
        setDigitalDenoms(allDenoms)
        setPrevClosingDenom(Object.fromEntries(digitalDenoms.map((d) => [d, 0])));
      }

      // Map opening denominations
      let mappedOpeningDenoms = Object.fromEntries(digitalDenoms.map((d) => [d, 0]));
      if (openingDenomsRes.data) {
                setDigitalDenoms(allDenoms)

        mappedOpeningDenoms = Object.fromEntries(
          digitalDenoms.map((d) => [d, Number(openingDenomsRes.data[String(d)]) || 0])
        );
      }
      // Calculate total of opening denominations
      const openingDenomTotal = digitalDenoms.reduce(
        (sum, d) => sum + d * mappedOpeningDenoms[d], 0
      );
      setTotalOpeningToday(openingDenomTotal);
            setIsLoading(false)

    } catch (err) {
            setIsLoading(false)

      console.error('Error fetching initial data:', err);
    }
  };
 
 const setEntryDate = async(e) =>{

    const selectedDate = new Date(e.target.value);
  
  // Create a Date object for today's date and zero out time components
  const today = new Date();
  today.setHours(18, 30, 0, 0);
    console.log("Ashmin checking for today :",today,selectedDate)
  // Check if selected date is in the future
  if (selectedDate > today) {
    alert("You cannot select a future date.");
    e.target.value = ""; // optionally reset the input
    return;
  }
    console.log(e.target.value)
    openingFormData.date = e.target.value
    closingFormData.date = e.target.value
    console.log(openingFormData)
    console.log(closingFormData)
    setDate(e.target.value)

  }
  const getStores = async()=>{
    setIsLoading(true)
    try{

     const storesRes = await axios.get(`${BACKEND_URL}/store`, { headers })
        setStores(storesRes.data);
        setIsLoading(false)
    }catch(err){
      setIsLoading(false)
      console.log("Error occured :",err)

    }
  }
   useEffect(()=>{
    if(userData?.roles?.role_name == "SUPER_ADMIN"){
        getStores()
        const queryStoreId = activeTab == 'opening' ? openingFormData.location:closingFormData.location;
        fetchAdminCashflowData(queryStoreId,date)
        openingFormData.location = queryStoreId
        closingFormData.location = queryStoreId
      
    }


  },[date])
  useEffect(()=>{
    if(userData?.roles?.role_name == "SUPER_ADMIN"){
        getStores()
        const queryStoreId = activeTab == 'opening' ? openingFormData.location:closingFormData.location;
        fetchAdminCashflowData(queryStoreId,date)
        openingFormData.location = queryStoreId
        closingFormData.location = queryStoreId
      
    }


  },[openingFormData.location,closingFormData.location])
  useEffect(() => { 
    fetchCurrencyDenoms();
    fetchDigitalSettlements();
   }, []);
   useEffect(()=>{
        fetchAllData();

   },[allDenoms])
  useEffect(() => {
    if (toggleBanking) return;
    const newDiscrepancies = {};
    digitalDenoms.forEach((d) => {
      newDiscrepancies[d] =
        Number(openingFormData.denom[d] || 0) !==
        Number(prevClosingDenom[d] || 0);
    });
    setDenomDiscrepancies(newDiscrepancies);
  }, [openingFormData.denom, prevClosingDenom]);

  // Handlers
  const handleIncrementBank = (denom) => {
    if (openingFormData.denom[denom] > 0) {
      console.log({
        ...openingFormData,
        denom: { ...openingFormData.denom, [openingFormData]: Number(openingFormData.denom[Number(denom)]) - 1 },
        bank: { ...openingFormData.bank, [denom]: Number(openingFormData.bank[Number(denom)] || 0) + 1 },
      })
      setOpeningFormData((prev) => ({
        ...prev,
        denom: { ...prev.denom, [denom]: prev.denom[denom] - 1 },
        bank: { ...prev.bank, [denom]: (Number(prev.bank[denom]) || 0) + 1 },
      }));
    }
  };
   const handleSelectAll = (denom) => {
    if (openingFormData.denom[denom] > 0) {
      setOpeningFormData((prev) => ({
        ...prev,
        denom: { ...prev.denom, [denom]:  0 },
        bank: { ...prev.bank, [denom]:( Number(prev.bank[denom]) || 0 )+ (Number(prev.denom[denom])||0) },
      }));
    }
  };
  const handleDecrementBank = (denom) => {
    if (openingFormData.bank[denom] > 0) {
      setOpeningFormData((prev) => ({
        ...prev,
        denom: { ...prev.denom, [denom]: prev.denom[denom] + 1 },
        bank: { ...prev.bank, [denom]: prev.bank[denom] - 1 },
      }));
    }
  };
  const handleOpeningChange = (e) => {
  const { name } = e.target;
  let value = e.target.value.replace(/-/g, ''); // remove minus signs

  // Fields that require floating number validation
  const floatFields = ['milkOrdered', 'milkReceived'];

  if (floatFields.includes(name)) {
    if (value === '') {
      setOpeningFormData(prev => ({ ...prev, [name]: '' }));
      setOpeningFormErrors(prev => ({ ...prev, [name]: undefined }));
      return;
    }
    const floatRegex = /^\d*\.?\d*$/;
    if (!floatRegex.test(value)) {
      // Ignore invalid input
      return;
    }
    // Optionally convert to number or keep string depending on your state use
    value = Number(value);
  }

  // For other fields, accept as is
  setOpeningFormData(prev => ({ ...prev, [name]: value }));

  const { valid, error } = validateField(name, value);
  setOpeningFormErrors(prev => ({ ...prev, [name]: valid ? undefined : error }));
  if(name == "milkOrdered" || name == "milkReceived"){
    var extraMilk = 0;
     if(name == "milkOrdered")
      extraMilk =  openingFormData.milkReceived - value 
    else
      extraMilk =value - openingFormData.milkOrdered  
    console.log("Extra Milk check :",extraMilk)
 const { valid, error } = validateField("milkExtra", extraMilk);
  setOpeningFormErrors(prev => ({ ...prev, ["milkExtra"]: valid ? undefined : error }));
        setOpeningFormData(prev => ({ ...prev, ["milkExtra"]:extraMilk }));
  
  }
};

  const handleClosingChange = (e) => {
  const { name } = e.target;
  let value = e.target.value.replace(/-/g, '');
   
  // Only validate floating numbers for these fields:
  const floatFields = ['salesPetPooja', 'expenses','pendingBills','dues_received'];
  
  if (floatFields.includes(name)) {
    if (value === '') {
      setClosingFormData(prev => ({ ...prev, [name]: '' }));
      setClosingFormErrors(prev => ({ ...prev, [name]: undefined }));
      return;
    }

    const floatRegex = /^\d*\.?\d*$/;
    if (!floatRegex.test(value)) {
      // Ignore invalid input
      return;
    }
        value = Number(value)
          setClosingFormData(prev => ({ ...prev, [name]: Number(value) }));

 
  } else {
  setClosingFormData(prev => ({ ...prev, [name]: value }));
  }


  const { valid, error } = validateField(name, value);
  setClosingFormErrors(prev => ({ ...prev, [name]: valid ? undefined : error }));
};

  const handleDenomChange = (e, type, denom, formType) => {
    const value = Number(e.target.value);
    // Allow only positive numbers with max 1 decimal, using input validation logic
    if (value === '' || /^([0-9]+(\.[0-9]?)?)$/.test(value)) {
      if (formType === 'opening') {
        setOpeningFormData((prev) => ({
          ...prev, [type]: { ...prev[type], [denom]: value }
        }));
      } else {
        setClosingFormData((prev) => ({
          ...prev, [type]: { ...prev[type], [denom]: value }
        }));
      }
      
    }
  };
  const handlePrevDayDenomChange = (e, type, denom, formType) => {
    const value = e.target.value;
    if (value === '' || /^([0-9]+(\.[0-9]?)?)$/.test(value)) {
      setPrevClosingDenom((prev) => ({
        ...prev,
        [denom]: value
      }));
    }
  };

  const handleOpeningSubmit = async (e) => {
    setIsLoading(true)
    e.preventDefault();
    setGlobalFormError('');
    const validationResult = validateForm(openingFormData, OPENING_FIELDS);
    const totalDenom = digitalDenoms.reduce(
  (sum, d) => sum + d * Number(openingFormData.denom[d] || 0),
  0
);
if (totalDenom <= 0) {
  validationResult.denomTotal = "Total opening denomination value must be greater than zero";
}
    setOpeningFormErrors(validationResult);
    if (Object.keys(validationResult).length > 0) {
      setGlobalFormError("Please fix the highlighted errors before submitting.");
          setIsLoading(false)

      return;
    }
    const confirmSubmission = window.confirm("Do you want to submit the opening report?")
    if(!confirmSubmission) {
      setIsLoading(false)
      return ;
    }
    try {
      //openingFormData.milkExtra = openingFormData.milkOrdered - openingFormData.milkReceived
      const payload = {
        ...openingFormData,
        // Ensure all numbers sent are numbers
        denom: Object.fromEntries(digitalDenoms.map((d) => [d, Number(openingFormData.denom[d] || 0)])),
        bank: Object.fromEntries(digitalDenoms.map((d) => [d, Number(openingFormData.bank[d] || 0)])),
        user_id: userData.id,
        status: flagDiscrepancy ? 'DISCREPANCY_FLAGGED' : '',
      };
      await axios.post(`${BACKEND_URL}/reports/opening`, payload,{headers : headers});
      fetchAllData();
      setOpeningFormData({
        date: getLocalFormattedDate(),
        location: userData.store_id || '',
        openingEmployee: userData.username || '',
        denom: Object.fromEntries(digitalDenoms.map((d) => [d, 0])),
        bank: Object.fromEntries(digitalDenoms.map((d) => [d, 0])),
        milkOrdered: '',
        milkReceived: '',
        milkExtra: '',
      });
      setOpeningFormErrors({});
      setActiveTab('closing')
      alert('Opening form submitted successfully!');
      setIsLoading(false)
    } catch (err) {
      setIsLoading(false)
      setGlobalFormError('Error submitting opening form.');
    }
  };

  const handleClosingSubmit = async (e) => {
    
    
    setIsLoading(true)
    e.preventDefault();
    setGlobalFormError('');
        const validationResult = validateForm(closingFormData, CLOSING_FIELDS);

    const totalClosingDenom = digitalDenoms.reduce(
  (sum, d) => sum + d * Number(closingFormData.closingDenom[d] || 0),
  0
);
if (totalClosingDenom <= 0) {
  validationResult.closingDenomTotal = "Total closing denomination value must be greater than zero";
}
    setClosingFormErrors(validationResult);
    if (Object.keys(validationResult).length > 0) {
      console.log("Form Data",closingFormData)
      setGlobalFormError("Please fix the highlighted errors before submitting.");
      setIsLoading(false)
      return;
    }
     const confirmSubmission = window.confirm("Do you want to submit the closing report?")
    if(!confirmSubmission) {
      setIsLoading(false)
      return ;
    }
    try {
      // Calculate required summary values
      const summary_physical_sale = digitalSettlementTotal + closingDenomTotal + Number(closingFormData.expenses) - totalOpeningToday;
      const summary_reported_sale = closingFormData.salesPetPooja;
      const summary_variance = summary_physical_sale - summary_reported_sale;
      const digital_sales = closingFormData.digitalSales
      const payload = {
        ...closingFormData,
        closingDenom: Object.fromEntries(digitalDenoms.map((d) => [d, Number(closingFormData.closingDenom[d] || 0)])),
        digital_sales,
        summary_physical_sale,
        summary_reported_sale,
        summary_variance,
        user_id: userData.id,
      };
      await axios.post(`${BACKEND_URL}/reports/closing`, payload,{headers : headers});
      fetchAllData();
      setClosingFormData({
        date: getLocalFormattedDate(),
        location: userData.store_id || '',
        closingEmployee: userData.username || '',
        closingDenom: Object.fromEntries(digitalDenoms.map((d) => [d, 0])),
        salesZomatoGold: '',
        salesPayTM: '',
        salesDineout: '',
        salesEasyDiner: '',
        salesAmex: '',
        salesSwiggy: '',
        salesZomato: '',
        salesKotak: '',
        salesPetPooja: '',
        expenses: '',
        pendingBills: '',
        remarks: '',
      });
      setClosingFormErrors({});
      alert('Closing form submitted successfully!');
      setIsLoading(false)
    } catch (err) {
      setIsLoading(false)
      setGlobalFormError('Error submitting closing form.');
    }
  };

  const prevClosingDenomTotal = digitalDenoms.reduce((sum, d) => sum + d * (Number(prevClosingDenom[d]) || 0), 0);
  const denomTotal = digitalDenoms.reduce((sum, d) => sum + d * (Number(openingFormData.denom[d]) || 0), 0);
  const bankTotal = digitalDenoms.reduce((sum, d) => sum + d * (Number(openingFormData.bank[d]) || 0), 0);
  const closingDenomTotal = digitalDenoms.reduce((sum, d) => sum + d * (Number(closingFormData.closingDenom[d]) || 0), 0);
  const extraMilk = openingFormData.milkOrdered - openingFormData.milkExtra
  const digitalSettlementTotal = closingFormData.digitalSales ? Object.values(closingFormData.digitalSales)
  .reduce((sum, value) => sum + Number(value || 0), 0) : 0;
  // Render logic
  const summaryLine = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '1.08rem',
    margin: '0 0 6px 0',
    fontWeight: 400,
    fontFamily: "'Segoe UI', 'Inter', Arial, sans-serif",
  };

  // Helper for rendering error
  const errorMsg = (err) =>
    err ? <div style={{ color: '#d24949', fontSize: '0.92em', margin: '5px 0 0 4px' }}>{err}</div> : null;

  // Helper for per-denomination errors
  const denomErrorMsg = (formErrors, denom) =>
    formErrors && formErrors[denom]
      ? <div style={{ color: '#d24949', fontSize: '0.91em', marginLeft: '4px' }}>{formErrors[denom]}</div>
      : null;

  return (
    <>
      {isLoading && <Loader />}
      <PageBody>
        <MainColumn>
          {/* Basic Info */}
          <CardSection>
            <CardTitle>Basic Information</CardTitle>
            <Row>
              <div style={{ flex: 1 }}>
                <Label>Date</Label>
                <Input type="date" value={date} onChange={(e)=>{setEntryDate(e)}}  disabled={!isAdmin}/>
              </div>
              <div style={{ flex: 1 }}>
                <Label>Location<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
                <Select
                  disabled={!isAdmin}
                  name="location"
                  value={activeTab === 'opening' ? openingFormData.location : closingFormData.location}
                  onChange={activeTab === 'opening' ? handleOpeningChange : handleClosingChange}
                  required
                >
                  <option value="" disabled>
                    Select Store
                  </option>
                  {stores.map((store) => (
                    <option key={store.id} value={store.id}>
                      {store.friendly_name}, {store.city}, {store.state}
                    </option>
                  ))}
                </Select>
              </div>
            </Row>
          </CardSection>
          {/* Tabs */}
          <ButtonRow>
            <TabButton disabled={todayReportStatus?.opening_report_filed || isAfterTenAM()} 
             style={{
                    cursor: (isAfterTenAM() || todayReportStatus?.opening_report_filed) ? 'not-allowed' : 'pointer',
                    backgroundColor: (isAfterTenAM() || todayReportStatus?.opening_report_filed) ? '#ccc' : '',
                    color: (isAfterTenAM() || todayReportStatus?.opening_report_filed) ? '#666' : '',
                    border: 'none', padding: '10px 16px', borderRadius: '4px', fontWeight: '600',
                  }}
            active={activeTab === 'opening'} onClick={() =>{ 
              if(!todayReportStatus?.opening_report_filed)
              setActiveTab('opening')
              }} 
              type="button">
              Opening (Morning)
            </TabButton>
            <TabButton disabled={todayReportStatus?.closing_report_filed || !todayReportStatus?.opening_report_filed} active={activeTab === 'closing'} 
             style={{
                    cursor: ( todayReportStatus?.closing_report_filed || !todayReportStatus?.opening_report_filed) ? 'not-allowed' : 'pointer',
                    backgroundColor: (todayReportStatus?.closing_report_filed || !todayReportStatus?.opening_report_filed) ? '#ccc' : '',
                    color: (todayReportStatus?.closing_report_filed || !todayReportStatus?.opening_report_filed) ? '#666' : '',
                    border: 'none', padding: '10px 16px', borderRadius: '4px', fontWeight: '600',
                  }}
            onClick={() => {
              if(!todayReportStatus?.closing_report_filed)
              setActiveTab('closing')
              
              }} type="button">
              Closing (Night)
            </TabButton>
          </ButtonRow>

          {/* Opening Form */}
          {activeTab === 'opening' && (
            <form onSubmit={handleOpeningSubmit} autoComplete="off">
              <CardSection>
                <CardTitle>Opening Section</CardTitle>
                <Label>Opening Employee</Label>
                <Input value={openingFormData.openingEmployee} disabled />
                <div style={{ display: 'flex', gap: '32px', alignItems: 'flex-start' }}>
                  {/* Opening Cash Denominations */}
                  <div style={{ flex: 1 }}>
                    <Label>Opening Cash Denominations<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
                    {digitalDenoms.map((d) => (
                      <DenominationRow key={d}
                        style={{
                          backgroundColor: denomDiscrepancies[d] ? 'rgba(255, 0, 0, 0.2)' : 'transparent',
                          transition: 'background-color 0.3s ease',
                        }}>
                        <LeftGroup>
                          <DenominationAmount>₹{d} x</DenominationAmount>
                          <DenominationInput
                            type="text"
                            inputMode="numeric"
                            min="0"
                            value={openingFormData.denom[d]}
                            onChange={(e) => handleDenomChange(e, 'denom', d, 'opening')}
                            disabled={toggleBanking || flagDiscrepancy}
                          />
                        </LeftGroup>
                        <DenominationTotal>₹{Number(d) * (Number(openingFormData.denom[d])||0)}</DenominationTotal>
                        {denomErrorMsg(openingFormErrors.denom, d)}
                      </DenominationRow>
                    ))}
                    <TotalsBox>Total Opening Cash: ₹{denomTotal}</TotalsBox>
                    {openingFormErrors.denomTotal && (
  <div style={{ color: 'red', fontSize: '0.9em', marginTop: '4px' }}>
    {openingFormErrors.denomTotal}
  </div>
)}
                  </div>
                  {/* Bank Deposit */}
                  <div style={{ flex: 1 }}>
                    {toggleBanking && (
                      <>
                        <Label>Bank Deposit</Label>
                        {digitalDenoms.map((d) => (
                          <DenominationRow key={d}>
                            <LeftGroup style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <DenominationAmount>₹{d} x</DenominationAmount>
                              <button
                                type="button"
                                disabled={openingFormData.bank[d] === 0}
                                onClick={() => handleDecrementBank(Number(d))}
                                style={{ width: '30px', height: '30px',color:'white',background :'#da1111ff', border:'1px solid #da1111ff',borderRadius: '2px',fontWeight:500 }}
                              >
                                −
                              </button>
                              <DenominationInput  
                              type="text"
                                inputMode="numeric"
                                  min="0"
                                step="0.1"
                                value={openingFormData.bank[Number(d)]}
                                disabled
                              />
                              <button
                                type="button"
                                disabled={openingFormData.denom[d] === 0}
                                onClick={() => handleIncrementBank(Number(d))}
                                style={{ width: '30px', height: '30px',color:'white',background :'#3772FF', border:'1px solid #3772FF',borderRadius: '2px',fontWeight:500 }}
                              >
                                +
                              </button>
                               <button
                                type="button"
                                disabled={openingFormData.denom[d] === 0}
                                onClick={() => handleSelectAll(Number(d))}
                                style={{ width: '80px', height: '30px',color:'white',background :'#3772FF', border:'1px solid #3772FF',borderRadius: '2px',fontWeight:500 }}
                              >
                                Select All
                              </button>
                            </LeftGroup>
                            <DenominationTotal>₹{d * (Number(openingFormData.bank[d])|| 0)}</DenominationTotal>
                            {denomErrorMsg(openingFormErrors.bank, d)}
                          </DenominationRow>
                        ))}
                        <TotalsBox>Total Banked: ₹{bankTotal}</TotalsBox>
                      </>
                    )}

                    {!toggleBanking && (
                      <>
                        <Label>Closing Cash Denomination (Previous Day)</Label>
                        {digitalDenoms.map((d) => (
                          <DenominationRow key={d}
                            style={{
                              backgroundColor: denomDiscrepancies[d] ? 'rgba(255, 0, 0, 0.2)' : 'transparent',
                              transition: 'background-color 0.3s ease',
                            }}>
                            <LeftGroup>
                              <DenominationAmount>₹{d} x</DenominationAmount>
                              <DenominationInput
                                type="number"
                                min="0"
                                step="0.1"
                                value={(prevClosingDenom[d]|| 0)}
                                disabled={true}
                                onChange={(e) => handlePrevDayDenomChange(e, 'prevClosingDenom', d, 'opening')}
                              />
                            </LeftGroup>
                            <DenominationTotal>₹{(Number(d) || 0) * (Number(prevClosingDenom[d]) || 0)}</DenominationTotal>
                          </DenominationRow>
                        ))}
                        <TotalsBox>Total Closing Cash (Previous Day): ₹{prevClosingDenomTotal}</TotalsBox>
        
                      </>
                    )}
                  </div>
                </div>

                {(!todayReportStatus?.opening_report_filed) && <div style={{ display: 'flex', gap: '16px', marginTop: '16px' }}>
                  {(!hasDiscrepancy && !toggleBanking) && (
                    <Button type="button" onClick={() => { setToggleBanking(true); setFlagDiscrepancy(false) }}>
                      Proceed to banking
                    </Button>
                  )}
                  {(hasDiscrepancy && !flagDiscrepancy) && (
                    <DiscrepancyButton type="button" onClick={() => { setToggleBanking(false); setFlagDiscrepancy(true) }}>
                      Flag discrepancy
                    </DiscrepancyButton>
                  )}
                </div>}
                {/* Milk Section */}
                <MilkRow>
                  <div style={{ flex: 1 }}>
                    <MilkLabel>Milk Ordered (Litres)<span style={{ color: 'red', marginLeft: '4px' }}>*</span></MilkLabel>
                    <MilkInput name="milkOrdered" value={openingFormData.milkOrdered} onChange={handleOpeningChange} />
                    {errorMsg(openingFormErrors.milkOrdered)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <MilkLabel>Milk Received (Litres)<span style={{ color: 'red', marginLeft: '4px' }}>*</span></MilkLabel>
                    <MilkInput name="milkReceived" value={openingFormData.milkReceived} onChange={handleOpeningChange} />
                    {errorMsg(openingFormErrors.milkReceived)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <MilkLabel>Extra Milk (Litres)<span style={{ color: 'red', marginLeft: '4px' }}>*</span></MilkLabel>
                    <MilkInput disabled name="milkExtra" value={ openingFormData.milkReceived  - openingFormData.milkOrdered } onChange={handleOpeningChange} />
                    {errorMsg(openingFormErrors.milkExtra)}
                  </div>
                </MilkRow>
                          <Label ><span style={{ color: 'red', marginLeft: '4px' }}>*</span> marked fields are required.</Label>

              </CardSection>
              {/* {globalFormError && errorMsg(globalFormError)} */}
              <ButtonRow>
                <Button type="submit"
                  disabled={isAfterTenAM() || todayReportStatus?.opening_report_filed}
                  style={{
                    cursor: (isAfterTenAM() || todayReportStatus?.opening_report_filed) ? 'not-allowed' : 'pointer',
                    backgroundColor: (isAfterTenAM() || todayReportStatus?.opening_report_filed) ? '#ccc' : '#007bff',
                    color: (isAfterTenAM() || todayReportStatus?.opening_report_filed) ? '#666' : '#fff',
                    border: 'none', padding: '10px 16px', borderRadius: '4px', fontWeight: '600',
                  }}
                >Submit Opening Entry</Button>
                {/* <ButtonSecondary onClick={() => setActiveTab('closing')}>Go to Closing</ButtonSecondary> */}
              </ButtonRow>
            </form>
          )}

          {/* Closing Form */}
          {activeTab === 'closing' && (
            <form onSubmit={handleClosingSubmit} autoComplete="off">
              <CardSection>
                <CardTitle>Closing Section</CardTitle>
                <Label>Closing Employee</Label>
                <Input value={closingFormData.closingEmployee} disabled />

                <Label>Closing Cash Denominations<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
                {digitalDenoms.map((d) => (
                  <DenominationRow key={d}>
                    <LeftGroup>
                      <DenominationAmount>₹{d} x</DenominationAmount>
                      <DenominationInput
                        type="text"
                        inputMode="numeric"
                        min="0"
                        value={closingFormData.closingDenom[d] || 0}
                        onChange={(e) => handleDenomChange(e, 'closingDenom', d, 'closing')}
                      />
                    </LeftGroup>
                    <DenominationTotal>₹{Number(d) * (Number(closingFormData.closingDenom[d]) || 0)}</DenominationTotal>
                  </DenominationRow>
                ))}
                <TotalsBox>Total Closing Cash: ₹{closingDenomTotal}</TotalsBox>
                                {closingFormErrors.closingDenomTotal && (
  <div style={{ color: 'red', fontSize: '0.9em', marginTop: '4px' }}>
    {closingFormErrors.closingDenomTotal}
  </div>
)}
                {/* Sales Breakdown Section */}
                <h2 style={{ fontWeight: 'bold', marginBottom: '16px' }}>Sales Breakdown</h2>
                {/* {[
                  ['Zomato Gold', 'salesZomatoGold', 'PayTM (Card + Machine)', 'salesPayTM'],
                  ['Dineout', 'salesDineout', 'Eazy Diner', 'salesEasyDiner'],
                  ['Amex', 'salesAmex', 'Swiggy', 'salesSwiggy'],
                  ['Zomato', 'salesZomato', 'Kotak', 'salesKotak'],
                ].map(([label1, name1, label2, name2]) => (
                  <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }} key={name1 + name2}>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                      <Label>{label1}</Label>
                      <InputDigitalSettlement
                        placeholder={label1}
                        name={name1}
                        value={closingFormData[name1]}
                        onChange={handleClosingChange}
                      />
                      {errorMsg(closingFormErrors[name1])}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                      <Label>{label2}</Label>
                      <InputDigitalSettlement
                        placeholder={label2}
                        name={name2}
                        value={closingFormData[name2]}
                        onChange={handleClosingChange}
                      />
                      {errorMsg(closingFormErrors[name2])}
                    </div>
                  </div>
                ))} */}
                {digitalSettlements.map(ds => (
  <div key={ds.id} style={{ display: 'flex', flexDirection: 'column', flex: 1, marginBottom: '1rem' }}>
    <Label htmlFor={ds.digital_settlement_name}>{ds.digital_settlement_name}</Label>
    <InputDigitalSettlement
      id={ds.digital_settlement_name}
      placeholder={ds.digital_settlement_name}
      name={ds.digital_settlement_name}
      value={closingFormData.digitalSales?.[ds.digital_settlement_name] || 0}
      onChange={e => {
  // Remove all minus signs from input string
  let value = Number(e.target.value.replace(/-/g, ''));

  // Update the input element value with cleaned string (removes the minus sign immediately)
  e.target.value = value || 0;

  // Validate: accept empty or numbers with optional single decimal digit (adjust regex as needed)
  if (value === '' || /^([0-9]+(\.[0-9]?)?)$/.test(value)) {
    value=Number(value)
    setClosingFormData(prev => ({
      ...prev,
      digitalSales: {
        ...prev.digitalSales,
        [ds.digital_settlement_name]: value,
      },
    }));
  }
}}

    />
  </div>
))}

                {/* Total Digital Settlements */}
                <div
                  style={{
                    backgroundColor: '#f8fbff',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    fontWeight: '600',
                    marginBottom: '16px',
                  }}
                >
                  Total Digital Settlements: ₹{digitalSettlementTotal}
                </div>

                {/* PetPooja + Expenses */}
                <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                  <div style={{  flex: 1 }}>
                    <Label>PetPooja Sales<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
                    <Input
                      placeholder="PetPooja Sales"
                      name="salesPetPooja"
                      value={closingFormData.salesPetPooja || 0}
                      onChange={handleClosingChange}
                    />
                    {errorMsg(closingFormErrors.salesPetPooja)}
                  </div>
                  <div style={{  flex: 1 }}>
                    <Label>Expenses<span style={{ color: 'red', marginLeft: '4px' }}></span></Label>
                    <Input
                      placeholder="Expenses"
                      name="expenses"
                      value={closingFormData.expenses || 0}
                      onChange={handleClosingChange}
                    />
                    {errorMsg(closingFormErrors.expenses)}
                  </div>
                </div>

                <Label>Pending Bills</Label>
                <Input
                  placeholder="Enter any pending bills..."
                  name="pendingBills"
                  value={closingFormData.pendingBills || 0}
                  onChange={handleClosingChange}
                />
                {errorMsg(closingFormErrors.pendingBills)}
                <Label>Dues Received</Label>
                <Input
                  placeholder="Enter any dues collected..."
                  name="dues_received"
                  value={closingFormData.dues_received || 0}
                  onChange={handleClosingChange}
                />
                {errorMsg(closingFormErrors.dues_received)}

                <Label>Notes / Remarks</Label>
                <Input
                  placeholder="Additional notes..."
                  name="remarks"
                  value={closingFormData.remarks}
                  onChange={handleClosingChange}
                />
                {/* no validation error for text/notes */}
                          <Label ><span style={{ color: 'red', marginLeft: '4px' }}>*</span> marked fields are required.</Label>

              </CardSection>
              {/* {globalFormError && errorMsg(globalFormError)} */}

              <InfoCard>
                <CardTitle>Summary</CardTitle>
                <div style={summaryLine}>
                  <span>Total Reported Sales (PetPooja):</span>
                  <SummaryValue>₹{closingFormData.salesPetPooja || 0}</SummaryValue>
                </div>
                <div style={summaryLine}>
                  <span>Physical Sale (  Closing  [₹{digitalSettlementTotal + closingDenomTotal}] + Expenses  [₹{closingFormData.expenses || 0}] - Opening  [₹{totalOpeningToday}]  ):</span>
                  <SummaryValue>₹{digitalSettlementTotal + closingDenomTotal + Number(closingFormData.expenses) - totalOpeningToday || 0}</SummaryValue>
                </div>
                <div style={summaryLine}>
                  <span>Variance ( Physical  [₹{digitalSettlementTotal + closingDenomTotal + Number(closingFormData.expenses) - totalOpeningToday || 0}] - Reported  [₹{closingFormData.salesPetPooja || 0}] ):</span>
                  <SummaryValue
                    {...( (digitalSettlementTotal + closingDenomTotal + Number(closingFormData.expenses) - totalOpeningToday) - closingFormData.salesPetPooja  >= 0
                      ? { positive: true }
                      : { negative: true }
                    )}
                  >
                    ₹{ (digitalSettlementTotal + closingDenomTotal + Number(closingFormData.expenses) - totalOpeningToday) - closingFormData.salesPetPooja }
                  </SummaryValue>
                 
                </div>
                 <div style={summaryLine}>
                  <span>Pending Bills:</span>
                  <SummaryValue>₹{closingFormData.pendingBills || 0}</SummaryValue>
                </div>
                <div style={summaryLine}>
                  <span>Dues Received:</span>
                  <SummaryValue>₹{closingFormData.dues_received ||  0}</SummaryValue>
                </div>
              </InfoCard>

              <ButtonRow>
                <Button
                  disabled={todayReportStatus?.closing_report_filed || !todayReportStatus?.opening_report_filed}
                  style={{
                    cursor: (todayReportStatus?.closing_report_filed || !todayReportStatus?.opening_report_filed) ? 'not-allowed' : 'pointer',
                    backgroundColor: (todayReportStatus?.closing_report_filed || !todayReportStatus?.opening_report_filed) ? '#ccc' : '#007bff',
                    color: (todayReportStatus?.closing_report_filed || !todayReportStatus?.opening_report_filed) ? '#666' : '#fff',
                    border: 'none', padding: '10px 16px', borderRadius: '4px', fontWeight: '600',
                  }}
                  type="submit">Submit Closing Entry</Button>
              </ButtonRow>
            </form>
          )}
        </MainColumn>
      </PageBody>
    </>
  );
}
